import { Badge, Tabs, Card, Select, DatePicker, Table } from "antd";
import Axios from "axios";
import React, { useRef, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadingArea from "../../components/LoadingArea";
import Dashboard from "../../layouts/Dashboard";
import url from "../../services/url";
import axios from "../../services/axios";
import moment from "moment";
import locations from "../../utils/api/locations";
import { Pagination } from "antd";
import { message } from "antd";
import exportFromJSON from "export-from-json";
import ReactLoading from "react-loading";
import useAxios from "../../hooks/useAxios";
import TRFIndicator from "../../components/components/TRFIndicator";
import useSearchContext from "../../hooks/useSearchContext";
import useTrfSearchContext from "../../hooks/useTrfSearchContext";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

const { Option } = Select;
const { RangePicker } = DatePicker;
const ALL_SELECT_VALUE = "__ALL__";

const normalizeFilterValues = (value) => {
  if (Array.isArray(value)) {
    return value.filter((item) => item !== "" && item !== null && item !== undefined);
  }

  if (value === "" || value === null || value === undefined) {
    return [];
  }

  return [value];
};

const serializeFilterValue = (value) => {
  const values = normalizeFilterValues(value);
  return values.length ? JSON.stringify(values) : "";
};

const filterSelectOption = (input, option) => {
  const searchText = input.toLowerCase();
  const label = String(option?.children ?? "").toLowerCase();
  const value = String(option?.value ?? "").toLowerCase();

  return label.includes(searchText) || value.includes(searchText);
};

function formatDate(d) {
  let date = new Date(d);
  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  let yyyy = date.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return (d = dd + "/" + mm + "/" + yyyy);
}

function TalentRequisitionFormList() {
  const id = localStorage.getItem("user.id");
  const {
    trfDepartment,
    setTrfDepartment,
    trfLocation,
    setTrfLocation,
    processId,
    setProcessId,
    title,
    setTitle,
    businessType,
    setBusinessType,
    assignUnassign,
    setAssignUnassign,
    defaultDate,
    setDefaultDate,
    tatDate,
    setTatDate,
    currentActive,
    setCurrentActive,
    currentInActive,
    setCurrentInActive,
    filterStatus,
    setFilterStatus,
    activeKey,
    setActiveKey,
    activeCount,
    setActiveCount,
    inActiveCount,
    setInActiveCount,
  } = useTrfSearchContext();

  const [activeTRF, setActiveTRF] = useState([]);
  const [inActiveTRF, setInActiveTRF] = useState([]);
  const [load, setLoad] = useState(false);
  const [preferredLocation, setPreferredLocation] = useState([]);
  const [asignedUser, setAsignedUser] = useState("");
  const [process, setProcess] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [jobTitleList, setJobTileList] = useState([]);
  const [assignedFilter, setAssignedFilter] = useState(null);
  const [showTrf, setShowTrf] = useState([]);
  const [canGetUsers, setCanGetUsers] = useState(false);
  const [canExportTrf, setCanExportTrf] = useState(false);
  const [canViewTrfDetails, setCanViewTrfDetails] = useState(false);
  const userRole = useRole();

  const departmentFilterOptions = [...new Set(
    departmentList?.map((dept) => dept?.department).filter(Boolean) || [],
  )];
  const locationFilterOptions = [...new Set(
    preferredLocation?.map((loc) => loc?.locationName).filter(Boolean) || [],
  )];
  const processFilterOptions = [...new Set(
    process?.map((opt) => opt?._id).filter(Boolean) || [],
  )];
  const jobTitleFilterOptions = [...new Set(jobTitleList?.filter(Boolean) || [])];
  const businessTypeFilterOptions = [...new Set(
    businessTypeList?.map((business) => business?.businessType).filter(Boolean) || [],
  )];
  const trfTypeFilterOptions = ["Assigned", "UnAssigned"];

  const handleMultiSelectChange = (value, optionValues, setter) => {
    const selectedValues = normalizeFilterValues(value);

    if (selectedValues.includes(ALL_SELECT_VALUE)) {
      const selectedWithoutAll = selectedValues.filter(
        (item) => item !== ALL_SELECT_VALUE,
      );
      const hasEveryOption =
        optionValues.length > 0 &&
        selectedWithoutAll.length === optionValues.length;

      setter(hasEveryOption ? [] : optionValues);
      return;
    }

    setter(selectedValues);
  };

  const buildTrfQueryString = (params) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      query.set(key, Array.isArray(value) ? serializeFilterValue(value) : value ?? "");
    });

    return query.toString();
  };

  const getRangePickerValue = (dateRange) => {
    if (!dateRange?.[0] || !dateRange?.[1]) return null;
    return [moment(dateRange[0], "YYYY-MM-DD"), moment(dateRange[1], "YYYY-MM-DD")];
  };

  const handleDate = (setDateRange) => (value, dateString) => {
    setDateRange(value === null ? ["", ""] : dateString);
  };

  const history = useHistory();
  const api = useAxios();
  const { setTrfId, setHeaderFilterStatus } = useSearchContext();

  const columns = [
    {
      title: "Job Title",
      dataIndex: "job_title",
      key: "job_title",
    },
    {
      title: "Business Type",
      dataIndex: "business_type",
      key: "business_type",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Process",
      dataIndex: "process",
      key: "process",
    },
    {
      title: "Vacancy Used",
      dataIndex: "used",
      key: "used",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value, row) => {
        const { record } = row || {};
        return (
          <TRFIndicator
            candidate={{
              trf: {
                Status: record?.trf?.Status,
                isTRFApproved: record?.trf?.isTRFApproved,
              },
            }}
          />
        );
      },
    },
    {
      title: "Raised On",
      dataIndex: "raised_on",
      key: "raised_on",
    },
    {
      title: "TAT Date",
      dataIndex: "tat_date",
      key: "tat_date",
    },
    {
      title: "TAT Start Date",
      dataIndex: "tatStartDate",
      key: "tatStartDate",
    },
    {
      title: "TAT End Date",
      dataIndex: "tatEndDate",
      key: "tatEndDate",
    },
  ];

  const onChangeActiveCurrent = async (page) => {
    try {
      setLoad(true);
      setCurrentActive(page);
      await getTRFData(activeKey === "1", true, page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const onChangeInActiveCurrent = async (page) => {
    try {
      setLoad(true);
      setCurrentInActive(page);
      await getTRFData(activeKey === "1", true, page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const exportType = "csv";
  let fileName = `TRF_REPORT_${moment(new Date()).format("DD-MM-YYYY_HH:mm")}`;

  const checkPermissions = async () => {
    try {
      const exportAllowed = await checkPermission(
        userRole,
        "trf_module",
        "export"
      );
      const viewDetailsAllowed = await checkPermission(
        userRole,
        "trf_module",
        "view_trf_details"
      );
      setCanExportTrf(exportAllowed);
      setCanViewTrfDetails(viewDetailsAllowed);
    } catch (err) {
      console.error("Error checking TRF permissions:", err);
    }
  };

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

    
  const loadCSV = async (status) => {
    try {
      setLoad(true);
      const queryString = buildTrfQueryString({
        Department: trfDepartment,
        Location: trfLocation,
        JobTitle: title,
        BusinessType: businessType,
        ProcessId: processId,
        StartDate: defaultDate[0],
        EndDate: defaultDate[1],
        tatStartDate: tatDate[0],
        tatEndDate: tatDate[1],
        userId: asignedUser,
        trfStatus: status,
        isTRFAssignable: "",
        isTRFAssigned: assignUnassign,
      });
      const { data } = await api.get(
        `/trf/Reports/DownloadTRFReports?${queryString}`,
        {
          tokenType: "user",
        },
      );
      const flattenArray = data?.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj, keyPrefix) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object") {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            }
          });
        }
        flatten(ele, "");
        return flatObject;
      });
      downloadCSV(flattenArray);
      setLoad(false);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoad(false);
    }
  };

  const downloadCSV = async (_data) => {
    const flattenArray = (data) => {
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };
    const data = flattenArray(_data);
    exportFromJSON({ data, fileName, exportType });
  };

  const getTRFData = async (_status, isFilterApply, page = undefined) => {
    try {
      const queryString = buildTrfQueryString({
        Department: isFilterApply ? trfDepartment : [],
        Location: isFilterApply ? trfLocation : [],
        PageNo: page ? page : activeKey === "1" ? currentActive : currentInActive,
        PageSize: 10,
        JobTitle: isFilterApply ? title : [],
        BusinessType: isFilterApply ? businessType : [],
        ProcessId: isFilterApply ? processId : [],
        StartDate: isFilterApply ? defaultDate[0] : "",
        EndDate: isFilterApply ? defaultDate[1] : "",
        tatStartDate: isFilterApply ? tatDate[0] : "",
        tatEndDate: isFilterApply ? tatDate[1] : "",
        userId: isFilterApply ? asignedUser : "",
        trfStatus: _status,
        isTRFAssignable: true,
        isTRFAssigned: isFilterApply ? assignUnassign : [],
      });
      const { data } = await api.get(
        `/trf/trfList?${queryString}`,
        { tokenType: "user" },
      );

      const response = data?.trf || [];
      let raw = [];

      for (let i = 0; i < response?.length; i++) {
        const { trf } = response[i] || {};
        const used = `${trf?.joinedCandidate} of ${trf?.numberOfVacancies +
          (trf?.bufferVacancyCount ? trf?.bufferVacancyCount : 0)
          } closed`;
        raw.push({
          key: i,
          job_title: (
            <div>
              {" "}
              <Badge color={_status ? "green" : "red"} className="mr-2" />{" "}
              {trf?.title || ""}
            </div>
          ),
          trfCloserDate: trf?.trfCloserDate
            ? formatDate(trf?.trfCloserDate)
            : "-",
          business_type: trf?.businessType || "-",
          department: trf?.department || "-",
          location: trf?.location || "-",
          process: trf?.processName || "-",
          used: used,
          raised_on: trf?.trfRaisedDate ? formatDate(trf?.trfRaisedDate) : "-",
          tat_date: trf?.tat ? formatDate(trf?.tat) : "-",
          tatStartDate: trf?.tatStartDate ? formatDate(trf?.tatStartDate) : "-",
          tatEndDate: trf?.tatEndDate ? formatDate(trf?.tatEndDate) : "-",
          action: "",
          record: response[i],
        });
      }
      if (_status) {
        setActiveTRF(raw);
        setActiveCount(data?.trfCount);
      } else {
        setInActiveTRF(raw);
        setInActiveCount(data?.trfCount);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoad(true);

        // Check permissions first to determine if we should fetch user list
        const getUsersAllowed = await checkPermission(
          userRole,
          "trf_module",
          "get_users"
        );
        setCanGetUsers(getUsersAllowed);

        const promise = [
          getLocations(),
          getProcessList(),
          getBusinessTypeList(),
          getDepartmentList(),
          getDistributedTrf(),
          getTRFData(activeKey === "1", true),
        ];

        if (getUsersAllowed) {
          promise.push(getUserList());
        }

        await Promise.all(promise);
      } catch (err) {
        console.error(err);
      } finally {
        setLoad(false);
      }
    };

    if (userRole) {
      init();
    }
  }, [userRole]);

  const getLocations = async () => {
    try {
      const { data } = await api.get(`/location`, {
        tokenType: "user",
      });

      setPreferredLocation(data?.locationMaster || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getJobTitleList = async () => {
    try {
      const queryString = buildTrfQueryString({
        Department: trfDepartment,
        Location: trfLocation,
        trfStatus: filterStatus,
        isTRFAssignable: "",
      });
      const { data } = await api.get(
        `/trf?${queryString}`,
        {
          tokenType: "user",
        },
      );
      const allTitle = data?.map((trf) => trf?.title);
      setJobTileList([...new Set(allTitle)]);
    } catch (err) {
      console.error(err);
    }
  };

  const getDistributedTrf = async (async) => {
    try {
      const { data } = await api.get(
        `/trfBasedUserMapping/distinctMapping/${id}/trfList`,
        {
          tokenType: "user",
        },
      );
      setShowTrf([...new Set([...data?.map((trf) => trf.trfId)])]);
    } catch (err) {
      console.error(err);
    }
  };

  const getProcessList = async () => {
    try {
      const { data } = await api.get(`/processes`, {
        tokenType: "user",
      });

      setProcess(data?.processes || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getDepartmentList = async () => {
    try {
      const { data } = await api.get(`/trfDepartment`, {
        tokenType: "user",
      });

      setDepartmentList(data?.trfDepartment || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getBusinessTypeList = async () => {
    try {
      const { data } = await api.get(`/samparkDomain`, {
        tokenType: "user",
      });

      setBusinessTypeList(data?.samparkDomainList || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getJobTitleList();
  }, [trfDepartment, trfLocation, filterStatus]);

  function onClickView(id, type, designationId, departmentId) {
    history.push(
      `/trf/${id}/view?type=${type}&designationId=${designationId}&departmentId=${departmentId}`,
    );
  }

  function onClickDelete(event) {
    const id = event.target.getAttribute("trf");
    Axios.delete(url("/trf/" + id), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((res) => {
        history.push("/trf");
      })
      .catch(console.error);
  }

  function handleTrf(trf) {
    setTrfId(trf);
    setHeaderFilterStatus("In_Process");
  }

  const getUserList = async () => {
    Axios.get(url("user"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((result) => {
        setUserList(result.data);
      })
      .catch(console.error);
  };

  const submitSearchHandler = async (e) => {
    try {
      setLoad(true);
      await getTRFData(activeKey === "1", true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const handleChange = async (value) => {
    const status = value === "1";
    try {
      setLoad(true);
      setCurrentInActive(1);
      setInActiveCount(0);
      setActiveCount(0);
      setCurrentActive(1);
      setActiveKey(value);
      setFilterStatus(status);
      setActiveTRF([]);
      setInActiveTRF([]);
      await getTRFData(status, true, 1);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  // const assignTrfNavigate = (e,_id) => {
  //   history.push("/trf/assign?id=" + _id );
  // }

  const tabItems = [
    {
      key: "1",
      label: "Active",
      children: (
        <div style={{ width: "100%" }}>
         
               <Table
            columns={[
              ...columns,
              {
                title: "Action",
                dataIndex: "action",
                key: "action",
                fixed: "right",
                render: (value, row) => {
                  const { record } = row || {};
                  console.log(row);
                  return (
                    <div
                      onClick={() => {
                        onClickView(
                          record?.trf?._id,
                          record?.trf?.candidateType,
                          record?.trf?.designationId,
                          record?.trf?.departmentId,
                        );
                      }}
                      className="cursor-pointer text-center"
                    >
                       {canViewTrfDetails && (
                      <i style={{ fontSize: "16px" }} class="fa fa-eye"></i>
                       )}
                    </div>
                  );
                },
              },
            ]}
            dataSource={activeTRF}
            pagination={{
              total: activeCount || 0,
              pageSizeOptions: ["5", "10", "30"],
              showSizeChanger: false,
              current: currentActive,
              onChange: onChangeActiveCurrent,
            }}
            showSorterTooltip={false}
            scroll={{ x: true }}
            style={{ whiteSpace: "pre" }}
            exportFileName="details"
            size="small"
          />
         
        </div>
      ),
    },
    {
      key: "2",
      label: "In Active",
      children: (
        <div style={{ width: "100%" }}>
        
                <Table
            columns={[
              ...columns,
              {
                title: "Batch Closure Date",
                dataIndex: "trfCloserDate",
                key: "trfCloserDate",
              },
              {
                title: "Action",
                dataIndex: "action",
                key: "action",
                fixed: "right",
                render: (value, row) => {
                  const { record } = row || {};
                  return (
                    <div
                      onClick={() => {
                        onClickView(
                          record?.trf?._id,
                          record?.trf?.bufferVacancyCount,
                        );
                      }}
                      className="cursor-pointer text-center"
                    >
                        {canViewTrfDetails && (
                      <i style={{ fontSize: "16px" }} class="fa fa-eye"></i>
                         )}
                    </div>
                  );
                },
              },
            ]}
            dataSource={inActiveTRF}
            pagination={{
              total: inActiveCount || 0,
              pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
              showSizeChanger: false,
              current: currentInActive,
              onChange: onChangeInActiveCurrent,
            }}
            showSorterTooltip={false}
            scroll={{ x: true }}
            style={{ whiteSpace: "pre" }}
            exportFileName="details"
            size="small"
          />
       
       
        </div>
      ),
    },
  ];

  return (
    <Dashboard title="Talent Requisition Form Listing">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="talent">
        <div className="row">
          <div className="col-12">
            <Card title="" className="border mt-3">
              <div className="row d-flex">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">Select Department</label>
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        maxTagCount="responsive"
                        style={{ width: "100%", minHeight: "37px" }}
                        placeholder="All Department"
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        value={trfDepartment}
                        onChange={(value) =>
                          handleMultiSelectChange(
                            value,
                            departmentFilterOptions,
                            setTrfDepartment,
                          )
                        }
                      >
                        <Option value={ALL_SELECT_VALUE}>Select All</Option>
                        {departmentFilterOptions?.map((department) => (
                          <Option key={department} value={department}>
                            {department}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">Select Location</label>
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        maxTagCount="responsive"
                        style={{ width: "100%", minHeight: "37px" }}
                        placeholder="All Location"
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        value={trfLocation}
                        onChange={(value) =>
                          handleMultiSelectChange(
                            value,
                            locationFilterOptions,
                            setTrfLocation,
                          )
                        }
                      >
                        <Option value={ALL_SELECT_VALUE}>Select All</Option>
                        {locationFilterOptions?.map((location) => (
                          <Option key={location} value={location}>
                            {location}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">Select Process</label>
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        maxTagCount="responsive"
                        style={{ width: "100%", minHeight: "37px" }}
                        placeholder="All Process"
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        value={processId}
                        onChange={(value) =>
                          handleMultiSelectChange(
                            value,
                            processFilterOptions,
                            setProcessId,
                          )
                        }
                      >
                        <Option value={ALL_SELECT_VALUE}>Select All</Option>
                        {process?.map(
                          (opt) =>
                            opt?.name && (
                              <Option key={opt?._id} value={opt?._id}>{opt?.name}</Option>
                            ),
                        )}
                      </Select>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">Select Job Title</label>
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        maxTagCount="responsive"
                        style={{ width: "100%", minHeight: "37px" }}
                        placeholder="All Job Title"
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        value={title}
                        onChange={(value) => {
                          handleMultiSelectChange(
                            value,
                            jobTitleFilterOptions,
                            setTitle,
                          );
                        }}
                      >
                        <Option value={ALL_SELECT_VALUE}>Select All</Option>
                        {jobTitleList?.map((title, index) => (
                          <Option key={title} value={title}>{`${title}`}</Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">
                        Select Business Type
                      </label>
                      <Select
                        id="city"
                        mode="multiple"
                        allowClear
                        showSearch
                        maxTagCount="responsive"
                        style={{ width: "100%", minHeight: "37px" }}
                        placeholder="All Business Type"
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        value={businessType}
                        onChange={(value) =>
                          handleMultiSelectChange(
                            value,
                            businessTypeFilterOptions,
                            setBusinessType,
                          )
                        }
                      >
                        <Option value={ALL_SELECT_VALUE}>Select All</Option>
                        {businessTypeFilterOptions?.map((business) => (
                          <Option key={business} value={business}>
                            {business}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">Trf Raised Date</label>
                      <RangePicker
                        style={{ height: "32px", width: "100%" }}
                        className=""
                        format="YYYY-MM-DD"
                        value={getRangePickerValue(defaultDate)}
                        onChange={handleDate(setDefaultDate)}
                        placeholder={[
                          moment(new Date()).format("YYYY-MM-DD"),
                          moment(new Date()).format("YYYY-MM-DD"),
                        ]}
                      />
                    </div>
                  </div>
                  <div className="row mt-2 ">
                    <div className="col-md-4">
                      <label htmlFor="candidate photo">Trf TAT Date</label>
                      <RangePicker
                        style={{ height: "32px", width: "100%" }}
                        className=""
                        format="YYYY-MM-DD"
                        value={getRangePickerValue(tatDate)}
                        onChange={handleDate(setTatDate)}
                        placeholder={[
                          moment(new Date()).format("YYYY-MM-DD"),
                          moment(new Date()).format("YYYY-MM-DD"),
                        ]}
                      />
                    </div>
                    {canGetUsers && (
                      <div className="col-md-4">
                        <label htmlFor="candidate photo">Select Trf Type</label>
                        <Select
                          mode="multiple"
                          allowClear
                          showSearch
                          maxTagCount="responsive"
                          style={{ width: "100%", minHeight: "37px" }}
                          placeholder="All"
                          optionFilterProp="children"
                          value={assignUnassign}
                          filterOption={filterSelectOption}
                          onChange={(value) =>
                            handleMultiSelectChange(
                              value,
                              trfTypeFilterOptions,
                              setAssignUnassign,
                            )
                          }
                        >
                          <Option value={ALL_SELECT_VALUE}>Select All</Option>
                          <Option value={"Assigned"}>Assigned</Option>
                          <Option value={"UnAssigned"}>UnAssigned</Option>
                        </Select>
                      </div>
                    )}
                    {/* <div className="col-md-4">
                              <label htmlFor="candidate photo">
                                Select Assigned/Unassigned Trf
                              </label>
                              <Select
                                showSearch
                                style={{ width: "100%", height: "37px" }}
                                placeholder="Select Assigned/Unassigned Trf"
                                optionFilterProp="children"
                                filterOption={(input, option) => {
                                  return (
                                    option?.children
                                      ?.toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0 ||
                                    option.value
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  );
                                }}
                                onChange={(value) => setAssignedFilter(value)}>
                                <Option value={null}>All</Option>
                                <Option value={true}>Assigned</Option>
                                <Option value={false}>Unassigned</Option>
                              </Select>
                            </div> */}
                    {/* {(localStorage.getItem("user.role") === "admin" ||
                              localStorage.getItem("user.role") === "hr") && (
                              <div className="col-md-4">
                                <label htmlFor="candidate photo">
                                  Select Recruiter
                                </label>
                                <Select
                                  showSearch
                                  style={{ width: "100%", height: "37px" }}
                                  placeholder="Select Recruiter"
                                  optionFilterProp="children"
                                  filterOption={(input, option) => {
                                    return (
                                      option?.children
                                        ?.toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0 ||
                                      option.value
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                  onChange={(value) => setAsignedUser(value)}>
                                  <Option value={""}>All</Option>
                                  {userList?.map(
                                    (user, index) =>
                                      user?.role === "interviewer" && (
                                        <Option value={user?._id}>
                                          {user?.name}
                                        </Option>
                                      )
                                  )}
                                </Select>
                              </div>
                            )} */}
                    <div
                      className="col-md-4 align-items-end d-flex"
                      style={{ gap: "1.5rem" }}
                    >
                      {canGetUsers && (
                        <button
                          style={{ flex: 1 }}
                          className={`btn ${"btn-primary"}`}
                          type="submit"
                          onClick={submitSearchHandler}
                      >
                        Search
                      </button>
                      )}
                      {canExportTrf && (
                      <button
                        style={{ flex: 1 }}
                        className={`btn btn-primary btn-block`}
                        type="submit"
                        onClick={() => loadCSV(activeKey === "1")}
                      >
                        Download
                      </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        <div className="my-2">
          <Card>
            <Tabs
              onChange={handleChange}
              defaultActiveKey={activeKey}
              items={tabItems}
            />
          </Card>
        </div>
      </div>
      {/* <Link
            to="/trf/create"
            className="btn my-4 btn-success btn-block w-25 mx-auto"
          >
            Add New
          </Link> */}
    </Dashboard>
  );
}

export default TalentRequisitionFormList;
